import { enumCoreAggregateType } from '@rematter/frontend-lib-api-client';
import { Col } from '@rematter/ui-web';

import {
  useCoreAggregateIdFilter,
  useCoreAggregateTypeFilter,
} from '../../_state/coreEvents.state';
import { useTranslations } from '../../i18n/useTranslations';

export const CoreEntityFilter = () => {
  const t = useTranslations();
  const [aggregateType] = useCoreAggregateTypeFilter();
  const [aggregateId, setAggregateId] = useCoreAggregateIdFilter();

  const getPlaceholder = () => {
    switch (aggregateType) {
      case enumCoreAggregateType.Organization:
        return t.coreEventsView.filter.selectOrganization;
      case enumCoreAggregateType.User:
        return t.coreEventsView.filter.selectUser;
      case enumCoreAggregateType.Facility:
        return t.coreEventsView.filter.selectFacility;
      case enumCoreAggregateType.FacilityGroup:
        return t.coreEventsView.filter.selectFacilityGroup;
      default:
        return '';
    }
  };

  return (
    <Col className="@CoreEntityFilter">
      <input
        type="text"
        value={aggregateId ?? ''}
        onChange={(e) => setAggregateId(e.target.value || undefined)}
        placeholder={getPlaceholder()}
        className="w-full rounded-md border border-neutral/20 bg-white px-3 py-2 text-sm placeholder:text-neutral/40 focus:border-primary focus:outline-none"
      />
    </Col>
  );
};
